<template>
    <div class="page-layout__inner w-50">
        <div class="page-layout__content">
            <form class="form" @submit.prevent="saveRole">
                <h4 class="section__title">{{ getTranslation('permissions') }}</h4><br/>
                <div v-for="(permissions, module) in modules" v-bind:key="module">
                    <label class="form__label">{{ getTranslation(module) }}</label>
                    <div class="checkbox-group  form__group">
                        <label class="checkbox" v-for="permission in permissions" v-bind:key="permission.id">
                            <input v-model="form.allows[module]" class="checkbox__input" type="checkbox" :value="permission.id"/>
                            <span class="checkbox__indicator  checkbox__indicator--inline"></span>
                            <span class="checkbox__label">{{ permission.description }}</span>
                        </label>
                    </div>
                </div>
                <div class="form__group">
                    <button class="btn btn--main">{{ getTranslation('save') }}</button>
                    <router-link :to="{ name: 'api.levels.getList' }" class="btn btn--main-outline">{{ getTranslation('cancel') }}</router-link>
                </div>
            </form>
        </div>
    </div>
</template>

<script>

    export default {
        name: "Edit",
        data() {
            return {
                role: {
                    id: '',
                    permission: []
                },
                roleId: this.$route.params.id,
                modules: [],
                form: {
                    allows: {},
                }
            }
        },
        updated() {
            this.setHeadings({
                title: this.role.title,
                breadcrumbs: [
                    {
                        label: this.getTranslation('levels'),
                        route: {name: 'api.levels.getList'}
                    },
                    {
                        label: this.role.title
                    }
                ]
            });
        },
        created() {
            this.fetchRole().then(() => this.fetchFormOptions());
        },
        methods: {
            fetchRole() {
                return this.axios.get(this.$config.urls.role.fetchLevel.url.replace(':id', this.roleId))
                    .then(response => {
                        this.role = response.data.data;
                    }).catch(()=>{});
            },
            fetchFormOptions() {
                return this.axios.get(this.$config.urls.role.fetchFormOptions.url)
                    .then(response => {
                        let modules = {};
                        for (let permission of response.data.data.permissions) {
                            if (modules[permission.module]) {
                                modules[permission.module].push(permission);
                                for (let p of this.role.permission) {
                                    if (p.id === permission.id) {
                                        this.form.allows[permission.module].push(permission.id);
                                    }
                                }
                            } else {
                                modules[permission.module] = [permission];
                                let pFound = false;
                                for (let p of this.role.permission) {
                                    if (p.id === permission.id) {
                                        pFound = true;
                                        this.form.allows[permission.module] = [permission.id];
                                        break;
                                    }
                                }
                                if (!pFound)
                                    this.form.allows[permission.module] = [];
                            }
                        }
                        this.modules = modules;
                    }).catch(()=>{});
            },
            saveRole() {
                let allows = [];
                Object.keys(this.form.allows).map(module => {
                    allows.push(...this.form.allows[module])
                });
                return this.axios.put(this.$config.urls.role.fetchLevel.url.replace(':id', this.roleId), {permission: allows})
                    .then(() => {
                        this.snotifySuccess('saveSuccessMsg');
                        this.loadUser(true);
                        this.$router.push({name: 'api.levels.getList'});
                    }).catch(()=>{});
            }
        }
    }
</script>

<style scoped>

</style>
